<template>
    <textarea :id="id" class="ckeditor-vue" :data-config="config" />
</template>

<script>
import { initCKEditorFromTextarea, disOrenableCKEditor, config } from 'src/lib/ckeditor-simple-init.js'

// Ckeditor component with v-model support
export default {
    props: {
        // Value
        value: {
            type: String,
            default: ''
        },
        config: {
            type: String,
            default: JSON.stringify(config)
        },
        disable: {
            type: Boolean,
            default: null,
        },
        // Used to disable ckeditor
        id: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        // Suppress emitting an `input` event when the CKEditor editor was
        // updated due to the Vue components `value` changing, i.e. we don't need
        // to inform the parent Vue components that the value changed when it was
        // the parent which changed the value.
        suppressInputEvent: false
    }),
    watch: {
        value: function(newval) {
            let current = this.editor.getData()
            // Avoid calling setData for data already in buffer
            if (newval !== current) {
                this.suppressInputEvent = true;
                this.editor.setData(newval)
            }
        },
        disable: function(d) {
            if (this.id) {
                if (d) {
                    disOrenableCKEditor(this.id, 'd')
                } else {
                    disOrenableCKEditor(this.id, 'e')
                }
            }
        }
    },
    mounted: function() {
        this.initializeEditor()
    },
    updated: function() {
        // Destroy previous editor to avoid replication
        this.destroyEditor()

        this.initializeEditor()
    },
    beforeDestroy: function() {
        this.destroyEditor()
    },
    methods: {
        destroyEditor: function() {
            // Reinitialize editor every time checking out
            this.editor.destroy()
            this.$el.removeAttribute("data-processed")
        },
        initializeEditor: function() {
            this.editor = initCKEditorFromTextarea(this.$el)
            this.editor.setData(this.value)
            // When mode is set attach listener to native input event
            this.editor.on('mode', () => {
                let editable = this.editor.editable()
                this.editor.on('change', this.onEditorChange)
                editable.attachListener(editable, 'keyup', this.watchTyping)
            })
        },
        onEditorChange: function() {
            if (this.suppressInputEvent) {
                this.suppressInputEvent = false;
                return;
            }
            // Compare to current value to avoid unnecessary events
            let current = this.editor.getData()
            if (current !== this.value) {
                if (this.checkWhiteSpace(current)) {
                    this.$emit('input', '')
                } else {
                    this.$emit('input', current)
                }
            }
        },
        watchTyping: function() {
            let current = this.editor.getData()
            this.$emit('keyup', current)
            // This is added to trigger emit for changes from source code, which are not received by 'change'
            if (current !== this.value) {
                this.$emit('input',current)
            }
        },
        // Check whether the input values of Ckeditor are all white space (&nbsp;)
        checkWhiteSpace: function (str) {
            const checkValue = str.replace('<p>', '').replace('</p>', '').replace(/\s/g,'')
            const valueSet = new Set(checkValue.split('&nbsp;'))
            return valueSet.size === 1 && valueSet.has('')
        }
    },
}
</script>
